<template>
  <div class="d-flex p-20 justify-content-center">

    {{ 'metainfo' | trans }}

  </div>
</template>
<script>
import store from './../../../mixins/store.mixin'

export default {
  name: "MetaInfo",
  props: {},
  components: {},
  mixins: [
    store
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {},
  computed: {}
};
</script>
<style lang="scss" scoped>
</style>
